import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../../pages/Home";
import NotFoundPage from "../../pages/NotFound/index";
import ShowInput from "../../pages/Showinput";
import AccoutSettingScreen from "../../pages/AccountSetting";
import RightSideAccountSetting from "../../components/RightAccountSetting/smallScreenSettings";
import EditProfile from "../../pages/EditProfile";
import SubcriptionAndPaymentScreen from "../../pages/PaymentsAndSubcription/index";
import Logout from "../../pages/Logout";
import DisplayCustomization from "../../pages/DisplayAndCustomization";
import LoginAgain from "../../pages/Logout/loginAgain";
import DisplayCustomizationSecond from "../../pages/DisplayAndCustomization/morecustomization";
import Airtel from "../../pages/PaymentMethods/MobileMoney/Airtel";
import PaymentContinueSecond from "../../pages/PaymentMethods/Visa/PaymentContinueSecond";
import PaymentMethod from "../../pages/PaymentMethods/Visa/PaymentMethod";
import Success from "../../pages/PaymentMethods/Visa/Success";
import CustomSlider from "../../pages/FeedBack";
import Smallscreencustomosation from "../../pages/DisplayAndCustomization/smallscreencustomosation";
import PaymentMethodSelection from "../../pages/PaymentsAndSubcription/PaymentMethodSelection";
import PaymentContinue from "../../pages/PaymentMethods/Visa/index";
import EnteringPhoneNumber from "../../pages/PaymentMethods/MobileMoney/Airtel/EnteringPin";
import Mtn from "../../pages/PaymentMethods/MobileMoney/Mtn";
import EnteringPin from "../../pages/PaymentMethods/MobileMoney/Mtn/EnteringPin";
import MasterCard from "../../pages/PaymentMethods/MasterCard";
import PaymentContMaterCard from "../../pages/PaymentMethods/MasterCard/PaymentContMasterCard";
import TextAndSpeachToSignLanguage from "../../pages/TextAndSpeachToSign";
import SpeachToSignLanguage from "../../pages/SpeachToSignLangauage";
import SignLanguageToText from "../../pages/SignLanguageToText";
import SignLanguageToSpeech from "../../pages/SignLanguageToTextAndSpeech";

import VerificationPage from "../../pages/verificationPage";
import ContactPage from "../../pages/Contacts";
import FAQPage from "../../pages/Faq";


export function PrivateRoute() {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<HomePage />} />
        <Route path="*" exact element={<NotFoundPage />} />
        <Route path="/input" exact element={<ShowInput />} />
        <Route path="/settings" exact element={<EditProfile />} />
        <Route path="/settings/profile" exact element={<EditProfile />} />
        <Route path="/settings/profile/edit" exact element={<RightSideAccountSetting />} />

        <Route path="/settings/logout" exact element={<Logout />} />
        <Route
          path="/settings/customization"
          exact
          element={<DisplayCustomization />}
        />
        <Route
          path="/settings/payment"
          exact
          element={<SubcriptionAndPaymentScreen />}
        />
        <Route path="/settings/feedback" exact element={<CustomSlider />} />
        <Route path="/loginagain" exact element={<LoginAgain />} />
        <Route
          path="/settings/customs"
          exact
          element={<DisplayCustomizationSecond />}
        />
        <Route path="c" exact element={<PaymentContinue />} />
        <Route
          path="/settings/paymentnextstep"
          exact
          element={<PaymentContinueSecond />}
        />
        <Route
          path="/settings/paymentmethod"
          exact
          element={<PaymentMethod />}
        />
        <Route
          path="/settings/paymentcont"
          exact
          element={<PaymentContinue />}
        />
        <Route path="/settings/success" exact element={<Success />} />
        <Route
          path="/settings/customise"
          exact
          element={<Smallscreencustomosation />}
        />
        <Route
          path="/settings/paymentselectionmethod"
          exact
          element={<PaymentMethodSelection />}
        />

        <Route
          path="/settings/paymentmethod/mobilemoney/airtel"
          exact
          element={<Airtel />}
        />
        <Route
          path="/settings/paymentmethod/mobilemoney/airtel/enteringphonenumber"
          exact
          element={<EnteringPhoneNumber />}
        />

        <Route
          path="/settings/paymentmethod/mobilemoney/mtn"
          exact
          element={<Mtn />}
        />
        <Route
          path="/settings/paymentmethod/mobilemoney/mtn/pin"
          exact
          element={<EnteringPin />}
        />
        <Route
          path="/settings/paymentmethod/mastercard"
          exact
          element={<MasterCard />}
        />
        <Route
          path="/settings/paymentmethod/mastercard/pay"
          exact
          element={<PaymentContMaterCard />}
        />
        <Route
          path="/textandspeechtosignlanguage"
          exact
          element={<TextAndSpeachToSignLanguage />}
        />
        <Route
          path="/signlanguagetotextandspeech"
          exact
          element={<SignLanguageToSpeech />}
        />
        <Route
          path="/signlanguagetotext"
          exact
          element={<SignLanguageToText />}
        />
        <Route
          path="/SpeachToSignLanguage"
          exact
          element={<SpeachToSignLanguage />}
        />
         <Route path="/verify" exact element={<VerificationPage/>} />
         <Route path="/faqs" exact element={<FAQPage/>} />
         <Route path="/support" exact element={<ContactPage/>} />


        
      </Routes>
    </>
  );
}
